import { render, staticRenderFns } from "./ContactsFormUpdate.vue?vue&type=template&id=53ebf95d&scoped=true&"
import script from "./ContactsFormUpdate.vue?vue&type=script&lang=js&"
export * from "./ContactsFormUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ContactsFormUpdate.vue?vue&type=style&index=0&id=53ebf95d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ebf95d",
  null
  
)

export default component.exports